import { useEntryContext } from '../context/EntryContext';

interface Props { fieldKey: string; label?: string }

export function EntryFieldBlock({ fieldKey, label }: Props) {
  const { entry } = useEntryContext();
  const value = entry.dataJson?.[fieldKey];
  if (value === undefined || value === null || value === '') return null;
  return (
    <div className="space-y-0.5">
      {label && <p className="text-xs font-semibold text-zinc-400 uppercase tracking-wide">{label}</p>}
      <p className="text-sm text-zinc-700">{String(value)}</p>
    </div>
  );
}
